import Security from './security.controller';

export default Security;
